module.exports = __webpack_public_path__ + "img/pos-leaderboard-badge-rank-3.475efd6e.svg";